import gql from 'graphql-tag';

const Query = {
  globalSearch: gql`
    query goGetIt($q: String) {
      goGetIt(filters: { q: $q }) {
        cmsPages {
          hits {
            id
            name
            description
            type
            parent {
              id
              type
              name
              color
            }
            covers {
              hits {
                public_url
              }
            }
          }
          nbHits
        }
      }
    }
  `,
};

const Mutation = {};

export default {
  Query,
  Mutation,
};
